import {
  FaAngleRight,
  FaChartLine,
  FaMoneyBill,
  FaServer,
} from "react-icons/fa";
import {
  CONSULTATRANSACAO,
  CONTASFIXAS,
  CREDITO,
  DASHBOARD,
  EXTRACTDETAIL,
  FINANCEIRO,
  LANCAMENTOSFUTUROS,
  LISTADEVENDAS,
  NOVAVENDASBOLETOS,
  PIXDIRECT,
  REGISTERFAVORITES,
  SUPORT,
  TAXASPESSOAIS,
  TRANSFERENCIAS,
  VENDADIGITADA,
  VENDAS,
  VENDASBOLETO,
  VENDASBOLEPIX,
  VENDASBOLETOS,
  LISTADEVENDASTEMPOREAL,
  TRANSFERENCIASNOVO,
  PAGAMENTOSNOVO,
  WPPSUPORT,
  TERMOSCLIENTES,
} from "../../../constants/paths";
import SideBarMenuItem from "./sideBarMenuItem";
import SideBarMenuItens from "./sideBarMenuItens";
import tela from "../../../assets/icons/icone-tela-inicio.png";
import calculadora from "../../../assets/icons/icone-calculadora.png";
import vendas from "../../../assets/icons/icone-vendas.png";
import credito from "../../../assets/icons/icone-crédito.png";
import calendario from "../../../assets/icons/icone-calendário-branco.png";
import { useRecoilState, useSetRecoilState } from "recoil";
import { allPermissions } from "../../../atoms/allPermissions";
import { permissions } from "../../../atoms/permissions";
import { useEffect, useState } from "react";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import PermissionsAPI from "../../../services/permissionsAPI";
import { Flex } from "@chakra-ui/react";

// [
//   {
//     "id": 1,
//     "nome": "ALL000", irrestrito
//     "descricao": null
//   },
//   {
//     "id": 2,
//     "nome": "PAG000", Solicitação de pagamento
//     "descricao": null
//   },
//   {
//     "id": 3,
//     "nome": "SRV000",
//     "descricao": null
//   },
//   {
//     "id": 4,
//     "nome": "SRV001",
//     "descricao": null
//   },
//   {
//     "id": 5,
//     "nome": "SRV002",
//     "descricao": null
//   },
//   {
//     "id": 6,
//     "nome": "TES000",
//     "descricao": null
//   },
//   {
//     "id": 7,
//     "nome": "TES001",
//     "descricao": null
//   },
//   {
//     "id": 8,
//     "nome": "TES002", Solicitações de pagamento
//     "descricao": null
//   },
//   {
//     "id": 9,
//     "nome": "TES003", Extrato
//     "descricao": null
//   },
//   {
//     "id": 10,
//     "nome": "TES004",
//     "descricao": null
//   },
//   {
//     "id": 11,
//     "nome": "TES005",
//     "descricao": null
//   },
//   {
//     "id": 12,
//     "nome": "VND000", venda por boleto
//     "descricao": null
//   },
//   {
//     "id": 13,
//     "nome": "VND001", nova venda
//     "descricao": null
//   },
//   {
//     "id": 14,
//     "nome": "REC000", venda reccorente
//     "descricao": null
//   },
//   {
//     "id": 15,
//     "nome": "REC001",
//     "descricao": null
//   },
//   {
//     "id": 16,
//     "nome": "REC002", cadastro de compradores
//     "descricao": null
//   },
//   {
//     "id": 17,
//     "nome": "REC003",
//     "descricao": null
//   },
//   {
//     "id": 18,
//     "nome": "REC004",
//     "descricao": null
//   },
//   {
//     "id": 19,
//     "nome": "REC005", visualização de transações de venda recorrente
//     "descricao": null
//   },
//   {
//     "id": 20,
//     "nome": "TSF000", solicitação de transferencia
//     "descricao": null
//   },
//   {
//     "id": 21,
//     "nome": "DIG000", venda digitada
//     "descricao": null
//   },
//   {
//     "id": 22,
//     "nome": "DIG001",
//     "descricao": null
//   },
//   {
//     "id": 23,
//     "nome": "DIG002", nova venda digitada
//     "descricao": null
//   }
//   {
//     "id": 25,
//     "nome": "DIG003", listagem de vendas
//     "descricao": null
//   }
//   {
//     "id": 26,
//     "nome": "VND002", listagem de vendas
//     "descricao": null
//   }
// ]

function SideBarMenuBuilder() {
  // const permissionsRecoil = useRecoilState(permissions)[0];
  // const setPermissionsRecoil = useSetRecoilState(permissions);
  // const [ permissionsList, setPermissionsList ] = useState(Array<{}>);

  // const token = window.localStorage.getItem("token");

  // let jwtToken: JWTToken = jwt_decode(token || "");

  // async function perms (id: any) {
  //   try {
  //     const response = await PermissionsAPI.getPermissions(id);
  //     setPermissionsList(response);
  //     setPermissionsRecoil(response);
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  // useEffect(() => {
  //   console.log("permissoes",permissionsList)
  //   if(permissionsList.length === 0){
  //     perms(Number(jwtToken.idCliente));
  //   }
  // },[permissionsList])

  return (
    <>
      <SideBarMenuItem
        text={"TERMOS DOS CLIENTES"}
        image={calendario}
        link={TERMOSCLIENTES}
      />
      <SideBarMenuItem
        text={"INICIO"}
        // icon={FaChartLine}
        image={tela}
        link={DASHBOARD}
      />
      {/* <SideBarMenuItem
        text={"FINANCEIRO"}
        iconArrow={FaAngleRight}
        link={FINANCEIRO}
      /> */}
      <SideBarMenuItens
        disabled={false}
        text={"FINANCEIRO"}
        image={calculadora}
        iconArrow={FaAngleRight}
        link={FINANCEIRO}
        item={[
          { EXTRATO: FINANCEIRO, id: 9 },
          { "CONSULTA DE TRANSAÇÕES": CONSULTATRANSACAO, id: 9 },
          { "LANÇAMENTOS FUTUROS": LANCAMENTOSFUTUROS, id: 9 },
          { "PAGAMENTO DE BOLETO": VENDASBOLETOS, id: 2 }, // 12
          { "PAGAMENTO DE BOLETO ONLINE": PAGAMENTOSNOVO, id: 37 },

          { TRANSFERÊNCIAS: TRANSFERENCIAS, id: 20 },
          { "TRANSFERÊNCIAS PIX": TRANSFERENCIASNOVO, id: 36 },
          // { "CADASTRO DE FAVORITOS": REGISTERFAVORITES, id: 20 },
          { "CADASTRO DE FAVORITOS": REGISTERFAVORITES, id: 36 },

          { "MINHAS TAXAS": TAXASPESSOAIS, id: 1 },
          { "CONTA FIXA": CONTASFIXAS, id: 1 },
        ]}
      />
      {/* <SideBarMenuItem text={"VENDAS"} iconArrow={FaAngleRight} link={VENDAS} /> */}
      <SideBarMenuItens
        disabled={false}
        item={[
          // { "VENDA BOLETO": NOVAVENDASBOLETOS, id: 12 },
          { "LISTA DE VENDAS": LISTADEVENDAS, id: 26 },
          { "LISTA DE VENDAS (TEMPO REAL)": LISTADEVENDASTEMPOREAL, id: 26 },
          // { "VENDAS DIGITADAS": VENDADIGITADA, id: 21 },
        ]}
        image={vendas}
        text={"MINHAS VENDAS"}
        iconArrow={FaAngleRight}
        link={VENDAS}
      />
      <SideBarMenuItens
        disabled={false}
        item={[
          { "VENDA BOLETO": VENDASBOLETO, id: 12 },
          //  { "VENDA BOLEPIX": VENDASBOLEPIX, id: 12 },
          // { "LISTA DE VENDAS": LISTADEVENDAS, id: 13 },
          { "VENDAS DIGITADAS": VENDADIGITADA, id: 21 },
          // { "VENDA PIX DIRETO": PIXDIRECT, id: 33 },
        ]}
        image={vendas}
        text={"NOVA VENDA"}
        iconArrow={FaAngleRight}
        link={VENDAS}
      />
      {/* <SideBarMenuItem text={"CRÉDITO"} iconArrow={FaAngleRight} link={CREDITO} /> */}
      <SideBarMenuItens
        disabled={true}
        item={[{ CREDITO: CREDITO, id: 9 }]}
        image={credito}
        text={"CRÉDITO"}
        iconArrow={FaAngleRight}
        link={CREDITO}
      />
      <SideBarMenuItens
        disabled={false}
        item={[{ "SOLICITAÇÕES DE SERVIÇOS": WPPSUPORT, id: 21 }]}
        image={calendario}
        text={"SUPORTE"}
        iconArrow={FaAngleRight}
        link={WPPSUPORT}
      />
    </>
  );
}
export default SideBarMenuBuilder;
